import { createSingleEntityStore } from '@core/ngrx-legacy';
import { PositionSkillEntity } from '@core/tellent-skills-types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<PositionSkillEntity>()(
  'PositionSkills',
  {
    customActions: adapter => ({
      fetchPositionSkills: (state, payload: { positionGuid: string }) =>
        adapter.markAsPending(state),
      clearPositionSkills: _state => adapter.markAsPending(adapter.reset()),
      fetchPositionSkillsSuccess: (state, payload: { data: PositionSkillEntity }) =>
        adapter.markAsLoaded(adapter.save(state, payload.data)),
      fetchPositionSkillsFailed: (state, payload: { error: unknown }) =>
        adapter.setError(state, payload.error),
      assignSkill: (
        state,
        payload: { positionGuid: string; skillId: number; proficiencyId: number },
      ) => adapter.markAsPending(state),
      assignSkillSuccess: state => adapter.markAsLoaded(state),
      assignSkillFailed: (state, payload: { error: unknown }) => adapter.markAsLoaded(state),
      updateSkill: (
        state,
        payload: { positionGuid: string; skillId: number; proficiencyId: number },
      ) => adapter.markAsPending(state),
      updateSkillSuccess: (state, payload: { skillId: number; proficiencyId: number }) =>
        adapter.markAsLoaded(
          adapter.update(state, {
            skills:
              state.data?.skills.map(assignedSkill =>
                assignedSkill.skill.id === payload.skillId
                  ? {
                      ...assignedSkill,
                      proficiency:
                        assignedSkill.skill.proficiencies?.find(
                          p => p.id === payload.proficiencyId,
                        ) ?? assignedSkill.proficiency,
                    }
                  : assignedSkill,
              ) ?? [],
          }),
        ),
      updateSkillFailed: (state, payload: { error: unknown }) => adapter.markAsLoaded(state),
      unassignSkill: (state, payload: { positionGuid: string; skillId: number }) =>
        adapter.markAsPending(state),
      unassignSkillSuccess: (state, payload: { skillId: number }) =>
        adapter.markAsLoaded(
          adapter.update(state, {
            skills: state.data?.skills.filter(s => s.skill.id !== payload.skillId) ?? [],
          }),
        ),
      unassignSkillFailed: (state, payload: { error: unknown }) => adapter.markAsLoaded(state),
      assignSkillMapping: (
        state,
        payload: { positionGuid: string; skillMappingId: number; levelId: number },
      ) => adapter.markAsPending(state),
      assignSkillMappingSuccess: state => adapter.markAsLoaded(state),
      assignSkillMappingFailed: (state, payload: { error: unknown }) => adapter.markAsLoaded(state),
      unassignSkillMapping: (
        state,
        payload: { positionGuid: string; skillMappingId: number; levelId: number },
      ) => adapter.markAsPending(state),
      unassignSkillMappingSuccess: (state, payload: { skillMappingId: number }) =>
        adapter.markAsLoaded(
          adapter.update(state, {
            skillMappings:
              state.data?.skillMappings.filter(m => m.id !== payload.skillMappingId) ?? [],
          }),
        ),
      unassignSkillMappingFailed: (state, payload: { error: unknown }) =>
        adapter.markAsLoaded(state),
    }),
  },
);

export {
  selectors as PositionSkillsSelectors,
  reducer as PositionSkillsReducer,
  actions as PositionSkillsActions,
  namespace as PositionSkillsNamespace,
};
